import React from 'react';

export const Stop = ({ width = '14', height = '14' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.40002C17.3019 2.40002 21.6 6.69809 21.6 12C21.6 17.302 17.3019 21.6 12 21.6C6.69806 21.6 2.39999 17.302 2.39999 12C2.39999 6.69809 6.69806 2.40002 12 2.40002ZM12 4.80002C8.02354 4.80002 4.79999 8.02357 4.79999 12C4.79999 15.9765 8.02354 19.2 12 19.2C15.9764 19.2 19.2 15.9765 19.2 12C19.2 8.02357 15.9764 4.80002 12 4.80002ZM15.6 10.8C16.2627 10.8 16.8 11.3373 16.8 12C16.8 12.6628 16.2627 13.2 15.6 13.2H8.39999C7.73725 13.2 7.19999 12.6628 7.19999 12C7.19999 11.3373 7.73725 10.8 8.39999 10.8H15.6Z"
        fill="white"
      />
    </svg>
  );
};
